import React, { useState } from 'react';
import Select from 'react-select'; // Import react-select
import HrLayout from '../../components/HrScheduleLayout.jsx'; // Import HrScheduleLayout component
import './hr-shift.css';

export default function HrShift() {
  const [shift, setShift] = useState(null);

  const shiftOptions = [
    { value: 'morning', label: 'Morning' },
    { value: 'afternoon', label: 'Afternoon' },
    { value: 'evening', label: 'Evening' },
    { value: 'night', label: 'Night' }
  ];

  const handleChange = (selectedOption) => {
    setShift(selectedOption);
  };

  return (
    <HrLayout>
      <div className='hr-shift-container'>
        <label htmlFor="shift-select" className='shift-label'>Select Shift:</label>
        <Select
          id="shift-select"
          value={shift}
          onChange={handleChange}
          options={shiftOptions}
          placeholder="--Shift--"
          className='shift-select'
          classNamePrefix='select'
        />
      </div>
    </HrLayout>
  );
}
